module.exports = __webpack_public_path__ + "img/img_side_thunder.e229ea39.png";